import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Topbar from '../../components/Bar/Topbar'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'

import { useParams } from 'react-router-dom'
import LandCruiserGallery from '../../components/Servicepages/LandCruiserGallery'
import Vehicles from '../../components/CarParc/Vehicles'



const RentCars = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
      className='bg-white'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
      <Topbar />
      <Header />
     
       <Vehicles />
    
     
      <Footer />
    </motion.div>
  )
}

export default RentCars
